<script>
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import moment from 'moment';
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'FNOL',
  data: () => ({
    fnolStep: 1,
    radios: {
      incidentInvolvement: [
        {
          key: 'Yes',
          value: true
        },
        {
          key: 'No',
          value: false
        }
      ]
    },
    formComplete: false,
    form: {
      firstName: null,
      lastName: null,
      email: null,
      insuranceProvider: null,
      policyNumber: null,
      telephoneNumber: null,
      altInsurer: '',
      incidentDate: null,
      incidentDescription: null,
      incidentLocation: null,
      incidentWitness: null,
      incidentWitnessInput: null,
      injuryEmergency: null,
      injuryEmergencyInput: null,
      insuredRelation: null,
      insuredRelationInput: null,
      ownerVehicleDamage: null,
      ownerVehicleDetails: null,
      ownerVehicleDriveable: null,
      ownerVehicleDriver: null,
      ownerVehicleInjury: null,
      ownerVehicleInjuryInput: null,
      ownerVehicleInvolved: null,
      ownerVehicleLocation: null,
      ownerVehicleLocationInput: null,
      otherVehicleDamage: null,
      otherVehicleDriveable: null,
      otherVehicleInjury: null,
      otherVehicleInjuryInput: null,
      otherVehicleInvolved: null,
      policeAgency: null,
      policeResponse: null
    },
    selectedDate: null,
    insurerOptions: [
      {
        label: 'Porsche Auto Insurance',
        value: 'Porsche Auto Insurance'
      },
      {
        label: 'Other',
        value: 'Other'
      }
    ],
    validationOptions: {
      phoneNumber: {
        phone: true,
        phoneRegionCode: 'US',
        delimiter: '-'
      }
    },
    ownerVehicleLocationOptions: [
      {
        label: 'Home',
        value: 'home'
      },
      {
        label: 'At a Dealer',
        value: 'dealer'
      },
      {
        label: 'At a Tow Yard',
        value: 'tow'
      },
      {
        label: 'Other',
        value: 'other'
      }
    ]
  }),
  computed: {
    autoCorrectedDatePipe() {
      return createAutoCorrectedDatePipe('mm/dd/yyyy');
    }
  },
  methods: {
    ...mapActions(['claimsFormSubmit']),
    ...mapMutations(['toggleLoader']),
    checkWorking(key, value) {
      let validator = this.$validator;
      validator.validate(key, value);
    },
    changedDate(event) {
      this.form.incidentDate = moment(event).format('MM/DD/YYYY');
      this.selectedDate = null;
      this.$el.querySelector('[name="incidentDate"]').focus();
      this.$validator.validate('incidentDate', this.form.incidentDate);
    },
    goBack() {
      if (this.fnolStep > 1) {
        this.fnolStep -= 1;
      }
      console.log('step: ', this.fnolStep);
    },
    goNext() {
      if (this.fnolStep < 5) {
        console.log('tru');
        this.fnolStep += 1;
      }
      console.log('step: ', this.fnolStep);
    },
    validateBeforeSubmit(event) {
      event.preventDefault();
      let firstErrorField;
      this.$validator
        .validateAll()
        .then(result => {
          if (result) {
            this.submitForm(this.form);
            return;
          }
          firstErrorField = this.$el.querySelector(
            '[name="' + this.$validator.errors.items[0].field + '"]'
          );
          firstErrorField.focus();
        })
        .catch(err => {
          console.log(err);
        });
    },
    submitForm(data) {
      this.toggleLoader({
        loaderText: 'Submitting...'
      });
      const cleanedData = {
        ...data,
        insuranceProvider: this.form.insuranceProvider.value,
        ownerVehicleLocation: this.form.ownerVehicleLocation.value,
        insuredRelation: this.form.insuredRelation
          ? 'INSURED'
          : 'OTHER (see insuredRelationInput)'
      };
      this.claimsFormSubmit(cleanedData)
        .then(() => {
          this.toggleLoader();
          this.$snackbar.open({
            type: 'is-success',
            position: 'is-bottom',
            message: `We've received your message, and someone from Claims Concierge will contact you soon.`,
            duration: 10000
          });
        })
        .catch(err => {
          this.toggleLoader();
          let message =
            err.msg ||
            'Something went wrong. Please try again later or contact our team via phone.';
          let toastType = 'is-danger';
          this.$snackbar.open({
            type: toastType,
            message: message,
            position: 'is-bottom'
          });
        });
    }
  }
};
</script>

<template>
  <form @submit.prevent="validateBeforeSubmit" class="has-placeholders form">
    <fieldset>
      <legend>First Notice of Loss Form</legend>
      <div v-show="fnolStep === 1" class="step-1">
        <label class="input -spacing-static-c">
          <input
            :class="{
              input__field: true
            }"
            name="firstName"
            type="text"
            placeholder="First Name"
            v-model="form.firstName"
            v-validate="'required'"
            required
            maxlength="63"
          />
          <span class="input__label">First Name</span>
        </label>
        <label class="input -spacing-static-c">
          <input
            :class="{
              input__field: true
            }"
            name="lastName"
            type="text"
            placeholder="Last Name"
            v-model="form.lastName"
            v-validate="'required'"
            required
            maxlength="63"
          />
          <span class="input__label">Last Name</span>
        </label>
        <label class="input -spacing-static-c phone-number-field">
          <cleave
            :class="{
              input__field: true
            }"
            name="mobilePhoneNumber"
            :options="validationOptions.phoneNumber"
            placeholder="Mobile Phone Number (000-000-0000)"
            v-model="form.telephoneNumber"
            v-validate="'phoneNumber'"
          ></cleave>
          <span class="input__label">
            Mobile Phone Number (000-000-0000)
          </span>
        </label>
        <label class="input -spacing-static-c">
          <input
            :class="{
              input__field: true,
              error: errors.has('emailAddress')
            }"
            name="emailAddress"
            type="email"
            placeholder="Email Address"
            v-model="form.email"
            v-validate="'required|email'"
            required
          />
          <span class="input__label">Email Address</span>
        </label>
        <div class="select-wrapper -spacing-static-c">
          <label
            for="insuranceProvider"
            :class="{
              error: errors.has('insuranceProvider')
            }"
            >Who is your Insurance Provider?</label
          >
          <v-select
            v-model="form.insuranceProvider"
            :searchable="false"
            :options="insurerOptions"
            v-validate="'required'"
            required
            name="insuranceProvider"
            :class="{
              error: errors.has('insuranceProvider')
            }"
          ></v-select>
        </div>
        <label
          class="input -spacing-static-c"
          v-if="
            form.insuranceProvider !== null &&
              form.insuranceProvider.value !== 'Porsche Auto Insurance'
          "
        >
          <input
            :class="{
              input__field: true,
              'fs-block': true,
              error: errors.has('altInsurer')
            }"
            name="altInsurer"
            placeholder="Name of Insurance Company"
            v-model="form.altInsurer"
          />
          <span class="input__label">Insurance Company</span>
        </label>
        <label class="input -spacing-static-c">
          <input
            :class="{
              input__field: true,
              'fs-block': true,
              error: errors.has('policyNumber')
            }"
            name="policyNumber"
            placeholder="What is your policy number (if available)?"
            v-model="form.policyNumber"
          />
          <span class="input__label">Policy Number</span>
        </label>
        <div class="radio-container">
          <label
            for="insuredRelation"
            style="display: block;"
            :class="{
              '-spacing-static-c': true,
              error: errors.has('insuredRelation')
            }"
          >
            Relationship to the Insured Person
          </label>
          <label
            class="input -spacing-static-c"
            key="insuredRelation"
            :class="{
              radio: true,
              error: errors.has('insuredRelation')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="insuredRelation"
              :value="true"
              v-model="form.insuredRelation"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              I am insured on the policy listed above
              <br />
            </span>
          </label>
          <label
            class="input -spacing-static-c"
            key="insuredRelationOther"
            :class="{
              radio: true,
              error: errors.has('insuredRelation')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="insuredRelationOther"
              v-model="form.insuredRelation"
              :value="false"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Other
              <br />
            </span>
          </label>
        </div>
        <label
          v-if="form.insuredRelation === false"
          class="input -spacing-static-c"
        >
          <input
            :class="{
              input__field: true,
              'fs-block': true,
              error: errors.has('insuredRelationInput')
            }"
            name="insuredRelationInput"
            placeholder="What is your relationship to the Insured Person?"
            v-model="form.insuredRelationInput"
          />
          <span class="input__label">Relationship to Insured</span>
        </label>
      </div>

      <div v-show="fnolStep === 2" class="step-2">
        <label class="input -spacing-static-c">
          <input
            :class="{
              input__field: true
            }"
            name="incidentLocation"
            type="text"
            placeholder="Where did the incident occur (location/address)?"
            v-model="form.incidentLocation"
            v-validate="'required'"
            required
            maxlength="128"
          />
          <span class="input__label"
            >Where did the incident occur (location/address)?</span
          >
        </label>
        <div class="limit-container">
          <label class="input -spacing-static-c">
            <masked-input
              :class="{
                input__field: true,
                error: errors.has('incidentDate')
              }"
              name="incidentDate"
              placeholder="Date of Incident (MM/DD/YYYY)"
              v-model="form.incidentDate"
              :keepCharPositions="true"
              v-validate="'required'"
              required
              :placeholderChar="'_'"
              @blur="checkWorking('incidentDate', form.incidentDate)"
              :pipe="autoCorrectedDatePipe"
              :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
              :guide="true"
            ></masked-input>
            <span class="input__label">When did the incident occur?</span>
          </label>
          <span class="icon calendar-icon">
            <vue-fontawesome :icon="['fas', 'calendar']" />
          </span>
          <b-datepicker
            name="incidentDate"
            @input="changedDate"
            v-model="selectedDate"
            :mobile-native="false"
          ></b-datepicker>
        </div>
        <label class="input -spacing-static-c">
          <input
            :class="{
              input__field: true
            }"
            name="incidentDescription"
            type="text"
            placeholder="Briefly describe the incident"
            v-model="form.incidentDescription"
            maxlength="256"
            v-validate="'required'"
            required
          />
          <span class="input__label">Briefly describe what happened</span>
        </label>
        <div class="radio-container">
          <label
            for="ownerVehicleInvolved"
            style="display: block;"
            :class="{
              '-spacing-static-c': true,
              error: errors.has('ownerVehicleInvolved')
            }"
          >
            Was your vehicle involved in the incident?
          </label>
          <label
            class="input -spacing-static-c"
            key="ownerVehicleInvolvedYes"
            :class="{
              radio: true,
              error: errors.has('ownerVehicleInvolved')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="ownerVehicleInvolvedYes"
              :value="true"
              v-model="form.ownerVehicleInvolved"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Yes
              <br />
            </span>
          </label>
          <label
            class="input -spacing-static-c"
            key="ownerVehicleInvolvedNo"
            :class="{
              radio: true,
              error: errors.has('ownerVehicleInvolved')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="ownerVehicleInvolvedNo"
              v-model="form.ownerVehicleInvolved"
              :value="false"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              No
              <br />
            </span>
          </label>
        </div>
        <label v-if="form.ownerVehicleInvolved" class="input -spacing-static-c">
          <input
            :class="{
              input__field: true
            }"
            name="vehicleDetails"
            type="text"
            placeholder="What is the Year, Make, Model, and Color of the vehicle (e.g. Red 2025 Ford F-150)?"
            v-model="form.ownerVehicleDetails"
            maxlength="200"
          />
          <span class="input__label">
            Year, Make, Model, and Color of your Vehicle (e.g. Red 2025 Ford
            F-150)
          </span>
        </label>
        <div
          v-if="form.ownerVehicleInvolved"
          class="select-wrapper -spacing-static-c"
        >
          <label
            for="ownerVehicleLocation"
            :class="{
              error: errors.has('ownerVehicleLocation')
            }"
            >Where is your vehicle now?</label
          >
          <v-select
            v-model="form.ownerVehicleLocation"
            :searchable="false"
            :options="ownerVehicleLocationOptions"
            name="ownerVehicleLocation"
            :class="{
              error: errors.has('ownerVehicleLocation')
            }"
          ></v-select>
        </div>
        <label
          v-if="
            form.ownerVehicleInvolved &&
              form.ownerVehicleLocation &&
              (form.ownerVehicleLocation === 'home' ||
                form.ownerVehicleLocation.value === 'home')
          "
          class="input -spacing-static-c"
        >
          <input
            type="text"
            v-model="form.ownerVehicleLocationInput"
            placeholder="What is your address?"
            name="ownerVehicleHomeAddress"
            :class="{
              input__field: true,
              error: errors.has('ownerVehicleHomeAddress')
            }"
          />
          <span class="input__label">
            Home address
          </span>
        </label>
        <label
          v-if="
            form.ownerVehicleInvolved &&
              form.ownerVehicleLocation &&
              (form.ownerVehicleLocation === 'dealer' ||
                form.ownerVehicleLocation.value === 'dealer' ||
                form.ownerVehicleLocation === 'tow' ||
                form.ownerVehicleLocation.value === 'tow')
          "
          class="input -spacing-static-c"
        >
          <input
            type="text"
            v-model="form.ownerVehicleLocationInput"
            placeholder="Do you have their contact phone number?"
            name="ownerVehicleHomeAddress"
            :class="{
              input__field: true,
              error: errors.has('ownerVehicleHomeAddress')
            }"
          />
          <span class="input__label">
            Phone number
          </span>
        </label>
        <label
          v-if="
            form.ownerVehicleInvolved &&
              form.ownerVehicleLocation &&
              (form.ownerVehicleLocation === 'other' ||
                form.ownerVehicleLocation.value === 'other')
          "
          class="input -spacing-static-c"
        >
          <input
            type="text"
            v-model="form.ownerVehicleLocationInput"
            placeholder="Vehicle Location"
            name="ownerVehicleLocationInput"
            :class="{
              input__field: true,
              error: errors.has('ownerVehicleLocationInput')
            }"
          />
          <span class="input__label">
            Location of vehicle
          </span>
        </label>
        <div v-if="form.ownerVehicleInvolved" class="radio-container">
          <label
            for="ownerVehicleDriveable"
            style="display: block;"
            :class="{
              '-spacing-static-c': true,
              error: errors.has('ownerVehicleDriveable')
            }"
          >
            Is your vehicle driveable?
          </label>
          <label
            class="input -spacing-static-c"
            key="Yes"
            :class="{
              radio: true,
              error: errors.has('ownerVehicleDriveable')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="ownerVehicleDriveableYes"
              :value="true"
              v-model="form.ownerVehicleDriveable"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Yes
              <br />
            </span>
          </label>
          <label
            class="input -spacing-static-c"
            key="No"
            :class="{
              radio: true,
              error: errors.has('ownerVehicleDriveable')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="ownerVehicleDriveableNo"
              v-model="form.ownerVehicleDriveable"
              :value="false"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              No
              <br />
            </span>
          </label>
        </div>
        <label v-if="form.ownerVehicleInvolved" class="input -spacing-static-c">
          <input
            :class="{
              input__field: true
            }"
            name="ownerVehicleDamage"
            type="text"
            placeholder="Briefly describe the damage to your vehicle"
            v-model="form.ownerVehicleDamage"
            maxlength="128"
          />
          <span class="input__label"
            >Briefly describe the damage to your vehicle</span
          >
        </label>
      </div>

      <div v-show="fnolStep === 3" class="step-3">
        <div class="radio-container">
          <label
            for="otherVehicleInvolved"
            style="display: block;"
            :class="{
              '-spacing-static-c': true,
              error: errors.has('otherVehicleInvolved')
            }"
          >
            Was another vehicle involved in the incident?
          </label>
          <label
            class="input -spacing-static-c"
            key="otherVehicleInvolvedYes"
            :class="{
              radio: true,
              error: errors.has('otherVehicleInvolved')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="otherVehicleInvolvedYes"
              :value="true"
              v-model="form.otherVehicleInvolved"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Yes
              <br />
            </span>
          </label>
          <label
            class="input -spacing-static-c"
            key="otherVehicleInvolvedNo"
            :class="{
              radio: true,
              error: errors.has('otherVehicleInvolved')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="otherVehicleInvolvedNo"
              v-model="form.otherVehicleInvolved"
              :value="false"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              No
              <br />
            </span>
          </label>
        </div>
        <div v-if="!!form.otherVehicleInvolved" class="radio-container">
          <label
            for="otherVehicleDriveable"
            style="display: block;"
            :class="{
              '-spacing-static-c': true,
              error: errors.has('otherVehicleDriveable')
            }"
          >
            Is the other vehicle driveable?
          </label>
          <label
            class="input -spacing-static-c"
            key="otherVehicleDriveableYes"
            :class="{
              radio: true,
              error: errors.has('otherVehicleDriveable')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="otherVehicleDriveableYes"
              :value="true"
              v-model="form.otherVehicleDriveable"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Yes
              <br />
            </span>
          </label>
          <label
            class="input -spacing-static-c"
            key="otherVehicleDriveableNo"
            :class="{
              radio: true,
              error: errors.has('otherVehicleDriveable')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="otherVehicleDriveableNo"
              v-model="form.otherVehicleDriveable"
              :value="false"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              No
              <br />
            </span>
          </label>
        </div>
        <label
          v-if="!!form.otherVehicleInvolved"
          class="input -spacing-static-c"
        >
          <input
            :class="{
              input__field: true
            }"
            name="otherVehicleDamage"
            type="text"
            placeholder="Briefly describe the damage to the other vehicle"
            v-model="form.otherVehicleDamage"
            maxlength="128"
          />
          <span class="input__label"
            >Briefly describe the damage to the other vehicle</span
          >
        </label>
      </div>

      <div v-show="fnolStep === 4" class="step-4">
        <div v-if="form.ownerVehicleInvolved" class="radio-container">
          <label
            for="ownerVehicleDriver"
            style="display: block;"
            :class="{
              '-spacing-static-c': true,
              error: errors.has('ownerVehicleDriver')
            }"
          >
            Who was driving your vehicle?
          </label>
          <label
            class="input -spacing-static-c"
            key="ownerVehicleDriver"
            :class="{
              radio: true,
              error: errors.has('ownerVehicleDriver')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="ownerVehicleDriver"
              value="Me"
              v-model="form.ownerVehicleDriver"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Me
              <br />
            </span>
          </label>
          <label
            class="input -spacing-static-c"
            key="ownerVehicleDriverOthers"
            :class="{
              radio: true,
              error: errors.has('ownerVehicleDriver')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="ownerVehicleDriverOthers"
              v-model="form.ownerVehicleDriver"
              value="Someone Else"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Someone Else
              <br />
            </span>
          </label>
        </div>
        <div v-if="form.ownerVehicleInvolved" class="radio-container">
          <label
            for="ownerVehicleInjury"
            style="display: block;"
            :class="{
              '-spacing-static-c': true,
              error: errors.has('ownerVehicleInjury')
            }"
          >
            Were there any injuries to you or passengers in your vehicle?
          </label>
          <label
            class="input -spacing-static-c"
            key="ownerVehicleInjuryYes"
            :class="{
              radio: true,
              error: errors.has('ownerVehicleInjury')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="ownerVehicleInjuryYes"
              :value="true"
              v-model="form.ownerVehicleInjury"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Yes
              <br />
            </span>
          </label>
          <label
            class="input -spacing-static-c"
            key="ownerVehicleInjuryNo"
            :class="{
              radio: true,
              error: errors.has('ownerVehicleInjury')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="ownerVehicleInjuryNo"
              v-model="form.ownerVehicleInjury"
              :value="false"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              No
              <br />
            </span>
          </label>
        </div>
        <label
          v-if="form.ownerVehicleInvolved && form.ownerVehicleInjury"
          class="input -spacing-static-c"
        >
          <input
            :class="{
              input__field: true
            }"
            name="ownerVehicleInjuryInput"
            type="text"
            placeholder="Please provide names, separated by comma."
            v-model="form.ownerVehicleInjuryInput"
          />
          <span class="input__label">
            Injured Party Names
          </span>
        </label>
        <div v-if="form.otherVehicleInvolved" class="radio-container">
          <label
            for="otherVehicleInjury"
            style="display: block;"
            :class="{
              '-spacing-static-c': true,
              error: errors.has('otherVehicleInjury')
            }"
          >
            Were there any injuries to passengers in the <i>other</i> vehicle?
          </label>
          <label
            class="input -spacing-static-c"
            key="otherVehicleInjuryYes"
            :class="{
              radio: true,
              error: errors.has('otherVehicleInjury')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="otherVehicleInjuryYes"
              :value="true"
              v-model="form.otherVehicleInjury"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Yes
              <br />
            </span>
          </label>
          <label
            class="input -spacing-static-c"
            key="otherVehicleInjuryNo"
            :class="{
              radio: true,
              error: errors.has('otherVehicleInjury')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="otherVehicleInjuryNo"
              v-model="form.otherVehicleInjury"
              :value="false"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              No
              <br />
            </span>
          </label>
        </div>
        <label
          v-if="form.otherVehicleInvolved && form.otherVehicleInjury"
          class="input -spacing-static-c"
        >
          <input
            :class="{
              input__field: true
            }"
            name="otherVehicleInjuryInput"
            type="text"
            placeholder="Please provide names, separated by comma."
            v-model="form.otherVehicleInjuryInput"
          />
          <span class="input__label">
            Injured Party Names
          </span>
        </label>
        <div class="radio-container">
          <label
            for="injuryEmergency"
            style="display: block;"
            :class="{
              '-spacing-static-c': true,
              error: errors.has('injuryEmergency')
            }"
          >
            Were any injured parties taken to a hospital or emergency care?
          </label>
          <label
            class="input -spacing-static-c"
            key="injuryEmergencyYes"
            :class="{
              radio: true,
              error: errors.has('injuryEmergency')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="injuryEmergencyYes"
              :value="true"
              v-model="form.injuryEmergency"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Yes
              <br />
            </span>
          </label>
          <label
            class="input -spacing-static-c"
            key="injuryEmergencyNo"
            :class="{
              radio: true,
              error: errors.has('injuryEmergency')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="injuryEmergencyNo"
              v-model="form.injuryEmergency"
              :value="false"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              No
              <br />
            </span>
          </label>
        </div>
        <label v-if="form.injuryEmergency" class="input -spacing-static-c">
          <input
            :class="{
              input__field: true
            }"
            name="injuryEmergencyInput"
            type="text"
            placeholder="Please provide names, separated by comma."
            v-model="form.injuryEmergencyInput"
          />
          <span class="input__label">
            Injured Party Names
          </span>
        </label>
        <div class="radio-container">
          <label
            for="incidentWitness"
            style="display: block;"
            :class="{
              '-spacing-static-c': true,
              error: errors.has('incidentWitness')
            }"
          >
            Were there any other witnesses to the incident?
          </label>
          <label
            class="input -spacing-static-c"
            key="incidentWitnessYes"
            :class="{
              radio: true,
              error: errors.has('incidentWitness')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="incidentWitnessYes"
              :value="true"
              v-model="form.incidentWitness"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Yes
              <br />
            </span>
          </label>
          <label
            class="input -spacing-static-c"
            key="incidentWitnessNo"
            :class="{
              radio: true,
              error: errors.has('incidentWitness')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="incidentWitnessNo"
              v-model="form.incidentWitness"
              :value="false"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              No
              <br />
            </span>
          </label>
        </div>
        <label v-if="form.incidentWitness" class="input -spacing-static-c">
          <input
            :class="{
              input__field: true
            }"
            name="incidentWitnessInput"
            type="text"
            placeholder="Please provide names (and contact info) for witnesses, separated by comma."
            v-model="form.incidentWitnessInput"
          />
          <span class="input__label">Witness Names (Contact Info)</span>
        </label>
      </div>

      <div v-show="fnolStep === 5" class="step-5">
        <div class="radio-container">
          <label
            for="policeResponse"
            style="display: block;"
            :class="{
              '-spacing-static-c': true,
              error: errors.has('policeResponse')
            }"
          >
            Did police or emergency services respond to the incident?
          </label>
          <label
            class="input -spacing-static-c"
            key="policeResponseYes"
            :class="{
              radio: true,
              error: errors.has('policeResponse')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="policeResponseYes"
              :value="true"
              v-model="form.policeResponse"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              Yes
              <br />
            </span>
          </label>
          <label
            class="input -spacing-static-c"
            key="policeResponseNo"
            :class="{
              radio: true,
              error: errors.has('policeResponse')
            }"
          >
            <input
              class="radio__field"
              type="radio"
              name="policeResponseNo"
              v-model="form.policeResponse"
              :value="false"
            />
            <span class="radio__icon icon icon--radio"></span>
            <span class="radio__label">
              No
              <br />
            </span>
          </label>
        </div>
        <label v-if="form.policeResponse" class="input -spacing-static-c">
          <input
            :class="{
              input__field: true
            }"
            name="policeAgency"
            type="text"
            placeholder="Which police department or emergency services agency?"
            v-model="form.policeAgency"
            maxlength="128"
          />
          <span class="input__label">Emergency Services Involved</span>
        </label>
        <label v-if="form.policeResponse" class="input -spacing-static-c">
          <input
            :class="{
              input__field: true
            }"
            name="policeReport"
            type="text"
            placeholder="What is the report number, if any, associated with the incident?"
            v-model="form.policeReport"
            maxlength="128"
          />
          <span class="input__label">Report Number</span>
        </label>
      </div>

      <div class="buttons">
        <button
          @click="goBack"
          type="button"
          :disabled="fnolStep === 1"
          class="button-primary button-primary--black -spacing-static-b back-button"
        >
          <span class="button-primary__icon icon icon--arrow-right-hair">
            <span class="loader-base button-primary__loader"></span>
          </span>
          <span class="button-primary__label">Back</span>
        </button>
        <button
          @click="goNext"
          type="button"
          :disabled="fnolStep === 5"
          class="button-primary button-primary--black -spacing-static-b back-button"
        >
          <span class="button-primary__icon icon icon--arrow-right-hair">
            <span class="loader-base button-primary__loader"></span>
          </span>
          <span class="button-primary__label">Next</span>
        </button>
        <button
          type="submit"
          :disabled="fnolStep < 5 && !formComplete"
          class="submit-button button-primary -spacing-static-b button-primary--black"
        >
          Submit
        </button>
      </div>
    </fieldset>
  </form>
</template>

<style scoped lang="scss">
div.buttons {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  :first-child {
    margin-left: 0;
  }
  :last-child {
    margin-right: 0;
  }
}
button {
  margin-left: 1em;
  margin-right: 1em;
}
button.submit-button {
  justify-self: flex-end;
}
</style>
